import { render, staticRenderFns } from "./chengScan.vue?vue&type=template&id=072bd126&scoped=true&"
import script from "./chengScan.vue?vue&type=script&lang=js&"
export * from "./chengScan.vue?vue&type=script&lang=js&"
import style0 from "./chengScan.vue?vue&type=style&index=0&id=072bd126&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072bd126",
  null
  
)

export default component.exports